/*
 * Informace o dopravě na produktové stránce.
 *
 * Statická věta o ceně dopravy je základ. Pokud už zákazník něco v košíku má,
 * dopočítáme, kolik mu s tímto produktem zbývá do dopravy zdarma — to je
 * konkrétnější než obecný práh a přímo pobízí k doplnění košíku.
 *
 * Počítá se v JS, ne v Liquidu: obsah závisí na košíku a Liquid by se
 * při cachování stránky mohl zaseknout na cizím stavu.
 */
(function () {
  'use strict';
  if (window._ilicoDoprava) return;
  window._ilicoDoprava = true;

  function koruny(halere) {
    try {
      return new Intl.NumberFormat('cs-CZ', {
        style: 'currency', currency: 'CZK', maximumFractionDigits: 0
      }).format(halere / 100);
    } catch (e) {
      return Math.round(halere / 100) + ' Kč';
    }
  }

  function init() {
    var box = document.querySelector('[data-ilico-doprava]');
    if (!box) return;

    var prah = parseInt(box.getAttribute('data-prah'), 10) || 0;      /* v haléřích */
    var cenaProduktu = parseInt(box.getAttribute('data-cena'), 10) || 0;
    var dopravne = parseInt(box.getAttribute('data-dopravne'), 10) || 119;
    var text = box.querySelector('[data-doprava-text]');
    if (!prah || !text) return;

    var zaklad = 'Doprava ' + dopravne + ' Kč kurýrem PPL, zdarma od ' + koruny(prah);
    text.textContent = zaklad;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var poPridani = (cart.total_price || 0) + cenaProduktu;

        if (poPridani >= prah) {
          box.classList.add('is-zdarma');
          text.textContent = cart.item_count > 0
            ? 'S tímto produktem máte dopravu zdarma'
            : 'S tímto produktem máte dopravu zdarma';
          return;
        }

        /* Košík je prázdný — obecná informace stačí, nemá smysl strašit částkou. */
        if (!cart.item_count) return;

        box.classList.add('is-blizko');
        text.textContent = 'S tímto produktem zbývá ' + koruny(prah - poPridani) + ' do dopravy zdarma';
      })
      .catch(function () { /* zůstane statická věta */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
